import Config from './Config';
// Click ids the ad platform appends to the landing page URL on an ad click.
// One-time per click — captured from the querystring, never from a cookie.
var QUERY_PARAM_ID_TYPES = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'li_fat_id'];
var COOKIE_MATCHES = [
    { idType: 'fbp', cookieName: '_fbp', pixelPresent: function () { return typeof window.fbq === 'function'; } },
    { idType: 'fbc', cookieName: '_fbc', pixelPresent: function () { return typeof window.fbq === 'function'; } },
    { idType: 'ttp', cookieName: '_ttp', pixelPresent: function () { return typeof window.ttq === 'object' || typeof window.ttq === 'function'; } },
];
function readCookie(name) {
    var escaped = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1');
    var match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
}
// Client-side dedupe guard: a click id/cookie already sent once for this
// device doesn't need to be re-identified on every subsequent pageview. Fails
// open (treats as "not sent yet") when localStorage is unavailable, e.g.
// private browsing — same posture as Tracker's shouldSendTraits guard.
function alreadySent(idType, value) {
    try {
        return localStorage.getItem("".concat(Config.LS_AD_MATCH_ID_SENT, ":").concat(idType, ":").concat(value)) !== null;
    }
    catch (_a) {
        return false;
    }
}
function markSent(idType, value) {
    try {
        localStorage.setItem("".concat(Config.LS_AD_MATCH_ID_SENT, ":").concat(idType, ":").concat(value), Date.now().toString());
    }
    catch (_a) {
        // Best effort — worst case the same id gets re-sent next pageview.
    }
}
/**
 * Capture ad-platform click ids (querystring) and first-party pixel cookies
 * present on this page, and hand each new one to `send`. Callers gate this
 * behind consent (see Tracker.startPipeline) — nothing here checks consent
 * itself.
 */
export function captureAdMatchIds(send) {
    var params = new URLSearchParams(window.location.search);
    for (var _i = 0, QUERY_PARAM_ID_TYPES_1 = QUERY_PARAM_ID_TYPES; _i < QUERY_PARAM_ID_TYPES_1.length; _i++) {
        var idType = QUERY_PARAM_ID_TYPES_1[_i];
        var value = params.get(idType);
        if (value && !alreadySent(idType, value)) {
            send(idType, value);
            markSent(idType, value);
        }
    }
    for (var _a = 0, COOKIE_MATCHES_1 = COOKIE_MATCHES; _a < COOKIE_MATCHES_1.length; _a++) {
        var _b = COOKIE_MATCHES_1[_a], idType = _b.idType, cookieName = _b.cookieName, pixelPresent = _b.pixelPresent;
        if (!pixelPresent())
            continue;
        var value = readCookie(cookieName);
        if (value && !alreadySent(idType, value)) {
            send(idType, value);
            markSent(idType, value);
        }
    }
}
